import { createQueryKeys } from "./create-query-keys";
import { getPositions } from "../api/generated/wrappers/backdata";
const positionQueryKeys = createQueryKeys("position", {
    all: () => ({
        queryKey: ["all"],
        queryFn: getPositions,
    }),
});
export default positionQueryKeys;
